import React, { useState, useEffect, useContext } from "react";
import axios from "../utils/axios";
import { AuthContext } from "../context/AuthContext";
import "./styles/RegularSMSViewer.css";

export default function RegularSMSViewer() {
  const { user, loading: authLoading } = useContext(AuthContext);

  const [date, setDate] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const [masterSites, setMasterSites] = useState([]);
  const [selectedMasterSite, setSelectedMasterSite] = useState("");
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const extractDecimal = (value) => {
    if (!value) return 0;
    if (typeof value === "object" && value.$numberDecimal) {
      return parseFloat(value.$numberDecimal);
    }
    return parseFloat(value);
  };

  useEffect(() => {
    fetchMasterSites();
  }, []);

  const fetchMasterSites = async () => {
    try {
      const res = await axios.get("/mastersites");
      setMasterSites(res.data);
    } catch (err) {
      console.error("Error fetching master sites", err);
    }
  };

  const fetchSites = async () => {
    try {
      const res = await axios.get("/sites");
      const filteredSites = res.data.filter(
        (site) => site.masterSiteId === selectedMasterSite
      );
      setSites(filteredSites);
    } catch (err) {
      console.error("Error fetching sites", err);
    }
  };

  useEffect(() => {
    if (selectedMasterSite) fetchSites();
  }, [selectedMasterSite]);

  const fetchRecords = async () => {
    setLoading(true);
    setError("");
    let url = "/sms?";
    const params = [];

    if (date) params.push(`date=${date}`);
    else if (from && to) params.push(`from=${from}&to=${to}`);
    if (selectedMasterSite) params.push(`masterSiteId=${selectedMasterSite}`);
    if (selectedSite) params.push(`siteId=${selectedSite._id}`);

    url += params.join("&");

    try {
      const res = await axios.get(url);
      setRecords(res.data);
    } catch (err) {
      console.error("Error fetching records:", err);
      setError("Error fetching records.");
    } finally {
      setLoading(false);
    }
  };

  // Restrict to admin only
  if (authLoading) return <p>Loading...</p>;
  if (!user || user.role !== "admin") return <p>🚫 Access denied. Admins only.</p>;

  return (
    <div className="sms-viewer">
      <h2>REGULAR Dispenser Records</h2>

      <div className="date-inputs">
        <label>
          Date (dd/mm/yyyy):
          <input
            type="text"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </label>

        <div className="or-text">OR</div>

        <label>
          From:
          <input
            type="text"
            value={from}
            onChange={(e) => setFrom(e.target.value)}
          />
        </label>
        <label>
          To:
          <input
            type="text"
            value={to}
            onChange={(e) => setTo(e.target.value)}
          />
        </label>
      </div>

      <div className="dropdowns">
        <label>Master Site:</label>
        <select
          value={selectedMasterSite}
          onChange={(e) => {
            setSelectedMasterSite(e.target.value);
            setSelectedSite(null);
          }}
        >
          <option value="">-- Select --</option>
          {masterSites.map((ms) => (
            <option key={ms._id} value={ms._id}>
              {ms.name}
            </option>
          ))}
        </select>

        {sites.length > 0 && (
          <>
            <label>Site:</label>
            <select
              onChange={(e) => {
                const site = sites.find((s) => s._id === e.target.value);
                if (site) setSelectedSite(site);
              }}
            >
              <option value="">-- Select --</option>
              {sites.map((site) => (
                <option key={site._id} value={site._id}>
                  {site.name}
                </option>
              ))}
            </select>
          </>
        )}

        <button onClick={fetchRecords}>Fetch Records</button>
      </div>

      {loading && <p>Loading...</p>}
      {error && <p className="error">{error}</p>}

      {records.length > 0 && (
        <table className="records-table">
          <thead>
            <tr>
              <th>Site</th>
              <th>Phone</th>
              <th>Date</th>
              <th>DateTime</th>
              <th>TDS</th>
              <th>pH</th>
              <th>Water (L)</th>
              <th>Amount (₹)</th>
            </tr>
          </thead>
          <tbody>
            {records.map((r, i) => (
              <tr key={i}>
                <td>{r.site}</td>
                <td>{r.phoneNumber}</td>
                <td>{r.date}</td>
                <td>{r.dateTime}</td>
                <td>{extractDecimal(r.tds)}</td>
                <td>{extractDecimal(r.ph)}</td>
                <td>{extractDecimal(r.totalWaterDispensed)}</td>
                <td>{extractDecimal(r.totalAmountCollected)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
